import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useSubIndustryUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }) => {
      const config = body instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
      const res = await api.put(`/subindustry/update/${id}`, body, config);
      return res.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["viewSubIndustry"] });
      queryClient.invalidateQueries({ queryKey: ["allSubIndustries"] });
      queryClient.invalidateQueries({ queryKey: ["subIndustriesList"] });
      if (variables?.id) {
        queryClient.invalidateQueries({ queryKey: ["subindustry", variables.id] });
      }
    },
  });
};